import RNDPgBackground from "../../Images/randdhero.webp";

const ResearchAndDevSection = () => {
  return (
    <section
      className="relative w-full min-h-[80vh] text-white bg-no-repeat bg-[position:70%] bg-cover sm:bg-top"
      style={{
        backgroundImage: `url(${RNDPgBackground})`,
      }}
    >
      <div className="pt-[12rem]" data-aos="fade-up">
        <section className="pb-6 px-6 bg-transparent ">
          <div className="text-left mb-6 max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-5xl lg:text-7xl font-semibold text-[#FFFFFF]">
              Semars Holding
            </h2>
            <p className="text-xl text-[#E5E5E5] py-2 md:py-6 max-w-2xl font-normal">
              Semars Holding Company, founded in 2024, is headquartered in
              Jeddah, Saudi Arabia, with a mission to provide high-end advisory
              and business support services for international companies. We
              specialize in helping foreign investors navigate the complexities
              of the Saudi market with tailored strategies and solutions
            </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default ResearchAndDevSection;
